import { styled } from '@mui/system';
import { COLORS } from './colors';

export const ToggleIndicatorContainer = styled('div')({
  padding: 4,
  height: 46,
  borderRadius: 23,
  boxShadow: `inset 0 0 0 1px ${COLORS.black[30]}`,
  display: 'flex',
  columnGap: 4,
});

export type ToggleIndicatorVariant = 'brand' | 'neutral';
interface ToggleIndicatorValueProps {
  isActive: boolean;
  variant: ToggleIndicatorVariant;
}
export const ToggleIndicatorValue = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'variant',
})<ToggleIndicatorValueProps>(({ isActive, variant }) => {
  const COLOR = {
    active: COLORS.white[100],
    default: COLORS.white[40],
  };
  let BACKGROUND_COLOR;

  switch (variant) {
    case 'brand':
      BACKGROUND_COLOR = COLORS.brand[100];
      break;
    case 'neutral':
    default:
      BACKGROUND_COLOR = COLORS.black[10];
  }

  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 38,
    borderRadius: 19,
    padding: '0 20px',
    color: isActive ? COLOR.active : COLOR.default,
    backgroundColor: isActive ? BACKGROUND_COLOR : 'transparent',
    fontWeight: 700,
  };
});
